import { render } from "./PrimeText.vue?vue&type=template&id=4e2e780a&scoped=true"
import script from "./PrimeText.vue?vue&type=script&lang=js"
export * from "./PrimeText.vue?vue&type=script&lang=js"

import "./PrimeText.vue?vue&type=style&index=0&id=4e2e780a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2e780a"]])

export default __exports__